module.exports = __webpack_public_path__ + "static/media/logo.af46165e.svg";